// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__3nxid","cell":"ColumnAccessor_cell__3-bdB","firstCellAccent":"ColumnAccessor_firstCellAccent__2Tu7N"};